// extracted by mini-css-extract-plugin
export var printerCard = "_hl-1";
export var printerCardConfigured = "_hl-2";
export var printerCardError = "_hl-3";
export var printerCardsContainer = "_hl-0";
export var printerIcon = "_hl-8";
export var printerIconConfigured = "_hl-5";
export var printerIconContainer = "_hl-4";
export var printerIconError = "_hl-6";
export var printerIconUnconfigured = "_hl-7";
export var workstationsTableCard = "_hl-9";